import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(
		private authenticationService: AuthenticationService,
		private authfackservice: AuthfakeauthenticationService,
		private router: Router
	) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const urls = ['auto_sign_up', 'get_lms_data', 'save_login', 'verify_master_login', 'get_list_widgets', 'get_database', 'save_dashboard', 'get_user_notifications', 'save_relation', 'get_numbers_lead', 'get_feedback_avg_user', 'get_address_lead', 'get_remaining'];
		const ipProviders = ['https://api.ipify.org/?format=json', 'https://ipapi.co/json/', 'https://bigdatacloud.net/data/client-ip', 'https://us1.api-bdc.net/data/client-info'];

		if (!ipProviders.some((url) => request.url.includes(url))) {
			if (!urls.some((url) => request.url.includes(url))) {
				let user = this.authenticationService.currentUser();
				if (!user || !this.isSameDay(user.loginTime)) {
					this.authenticationService.logout();
					this.router.navigateByUrl('/auth/signin/cover');
				}
			}

			if (environment.defaultauth === 'firebase') {
				// add authorization header with jwt token if available
				let currentUser = this.authenticationService.currentUser();
				if (currentUser && currentUser.jwt) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${currentUser.jwt}`,
						},
					});
				}
			} else {
				// add authorization header with jwt token if available
				const currentUser = this.authfackservice.currentUserValue;
				if (currentUser && currentUser.token) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${currentUser.token}`,
						},
					});
				}
			}
		}

		return next.handle(request);
	}

	isSameDay(fecha) {
		return dayjs().isSame(dayjs(fecha), 'day');
	}
}
